import * as React from "react";
import { DysplasiaList } from "../DysplasiaList";
import { ETLCodes } from "../../../locales";
import { ECommissionType } from "../../../api";

export interface IComissionDysplasiaListProps {}

export const ComissionDysplasiaList: React.FunctionComponent<IComissionDysplasiaListProps> = (props) => {
  return (
    <DysplasiaList
      isAppeal={false}
      breadcrumbText={ETLCodes.Commissions}
      comissionType={ECommissionType.ClassicCommission}
    />
  );
};
